import { initializeApp, getApps } from 'firebase/app'
import { getAnalytics, isSupported as analyticsSupported } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyBqfqdXip7gwzKQS_qrzYqJSMDOclIG4b0",
    authDomain: "corporate-connectionz.firebaseapp.com",
    projectId: "corporate-connectionz",
    storageBucket: "corporate-connectionz.firebasestorage.app",
    messagingSenderId: "764416693532",
    appId: "1:764416693532:web:370bd12eea9f9bef2dd6d9",
    measurementId: "G-1R931PCG9C"
  };
  

// Prevent re-init during HMR
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)

// Core services
const auth = getAuth(app)
const db = getFirestore(app)
const storage = getStorage(app)
const functions = getFunctions(app, 'us-central1')

// Analytics (browser-only, guards SSR/tests)
let analytics = null
if (typeof window !== 'undefined') {
  analyticsSupported().then((ok) => {
    if (ok) analytics = getAnalytics(app)
  })
}

export { app, auth, db, storage, functions, analytics }